import { FilterTemplate } from "@/models/Filter";
import { ModeTemplate } from "@/models/Mode";
import { Option, CategoryOption } from "@/models/Option";

export interface SelectorState {
    config: any[];
    selectedConfigIndex: number;
    modes: ModeTemplate[];
    availableTypes: string[];
    selectedTypes: string[];
    filters: Array<FilterTemplate>;
    availableCategories: Array<CategoryOption>;
    selectedCategory: string;
    selectedProduct: string;
}

export default {
    namespaced: true as true,
    state: {
        config: [],
        modes: [],
        selectedConfigIndex: 0,
        availableTypes: [],
        selectedTypes: [],
        filters: [],
        availableCategories: [],
        selectedCategory: '',
        selectedProduct: ''
    } as SelectorState,
    getters: {
        getSelectedConfig: (state: SelectorState) => state.config[state.selectedConfigIndex],
        getSelectedMode: (state: SelectorState) => state.modes[state.selectedConfigIndex],
        getAvailableProducts: (state: SelectorState): any[] => {
            if(state.availableCategories.length > 0) {
                const category = state.availableCategories.find(x => x.Value === state.selectedCategory);
                return category === undefined
                ? []
                : category.Products.map(product => {
                    return { label: product.Label, value: product.Value };
                });
            }
            return [];
        },
        getSelectedCategory: (state: SelectorState) => {
            const category = state.availableCategories.find(x => x.Value === state.selectedCategory);
            return {
                label: category?.Label,
                value: category?.Value
            }
        },
    },
    mutations: {
        TOGGLE_SELECTED_TYPE(state: SelectorState, type: string) {
            if(state.selectedTypes.includes(type)) {
                state.selectedTypes = state.selectedTypes.filter(t => t !== type);
            }
            else {
                state.selectedTypes.push(type);
            }
        },
        SET_AVAILABLE_TYPES(state: SelectorState, types: string[]) {
            state.availableTypes = types;
        },
        SET_SELECTED_TYPES(state: SelectorState, types: string[]) {
            state.selectedTypes = types;
        },
        SET_MODES(state: SelectorState, modes: ModeTemplate[]) {
            state.modes = modes;
        },
        SET_CONFIG(state: SelectorState, config: any[]) {
            state.config = config;
        },
        SELECT_CONFIG(state: SelectorState, index: number) {
            state.selectedConfigIndex = index;
        },
        SET_FILTERS(state: SelectorState, filters: FilterTemplate[]) {
            state.filters = filters;
        },
        SET_CATEGORIES(state: SelectorState, categories: Array<CategoryOption>) {
            state.availableCategories = categories;
        },
        SELECT_CATEGORY(state: SelectorState, category: string) {
            state.selectedCategory = category;
        },
        SELECT_PRODUCT(state: SelectorState, product: string) {
            state.selectedProduct = product;
        }
    },
    actions: {
        async setTypes({ commit }: any, payload: { config: any }) {
            if(payload.config.SelectedTypes) {
                commit('SET_SELECTED_TYPES', payload.config.SelectedTypes)
            }
            if(payload.config.AvailableTypes) {
                commit('SET_AVAILABLE_TYPES', payload.config.AvailableTypes)
            }
        },
        async initConfig({ commit, state }: any, payload: { config: any[] }) {
            commit("SET_CONFIG", payload.config);
            commit("SELECT_CONFIG", 0);
            const modes = payload.config.map(c => c.Mode as ModeTemplate);
            commit("SET_MODES", modes);
            commit('SET_FILTERS', payload.config[state.selectedConfigIndex].Filters)
            commit('SET_SELECTED_TYPES', payload.config[state.selectedConfigIndex].SelectedTypes)
            commit('SET_AVAILABLE_TYPES', payload.config[state.selectedConfigIndex].AvailableTypes)
        },
        async selectConfig({ commit, state }: any, payload: { index: number}) {
            commit("SELECT_CONFIG", payload.index);
            commit('SET_FILTERS', state.config[state.selectedConfigIndex].Filters)
            commit('SET_SELECTED_TYPES', state.config[state.selectedConfigIndex].SelectedTypes)
            commit('SET_AVAILABLE_TYPES', state.config[state.selectedConfigIndex].AvailableTypes)
        },
        async initCategories({ commit }: any, payload: { categoriesConfig: CategoryOption[] }) {
            if(Array.isArray(payload.categoriesConfig)) {
                commit('SET_CATEGORIES', payload.categoriesConfig);
            }
            const selectedCategory = payload.categoriesConfig.find(
                x => x.Selected === true
              );
              if (selectedCategory) {
                  commit('SELECT_CATEGORY', selectedCategory.Value);
        
                const selectedProduct = ((selectedCategory as any).Products as Array<
                  Option
                >).find(x => x.Selected === true);
                if (selectedProduct) {
                    commit('SELECT_PRODUCT', selectedProduct.Value);
                }
              }
        },
        async selectCategory({ commit, state }: any, payload: { categoryId: any}) {
            commit('SELECT_CATEGORY', payload.categoryId);
            const selectedCategory = state.availableCategories.find((x: CategoryOption) => x.Value === payload.categoryId) as CategoryOption;
            let selectedProduct = selectedCategory.Products.find((x: Option) => x.Selected);
            if(!selectedProduct) {
                selectedProduct = selectedCategory.Products[0];
            }
            commit('SELECT_PRODUCT', selectedProduct.Value)
        }
    }
}